import React from 'react'

export default function RotateIcon() {
  return (
    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 0v2c3.859 0 7 3.14 7 7s-3.141 7-7 7-7-3.14-7-7c0-1.847.735-3.586 2-4.882V6.5h2V1H.5v2h1.791A8.992 8.992 0 0 0 0 9c0 4.962 4.037 9 9 9s9-4.038 9-9-4.037-9-9-9"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
